module.exports = new Promise(function (resolve, reject) {
    var resolveHost = function (baseUrl, hostname) {
  var greenHostMarker = "-green.corksy.io"
  if (!baseUrl || !hostname || hostname.indexOf(greenHostMarker) === -1) {
    return baseUrl
  }
  try {
    var url = new URL(baseUrl)
    if (url.hostname.indexOf(greenHostMarker) !== -1) {
      return baseUrl
    }
    if (!/\.corksy\.io$/i.test(url.hostname)) {
      return baseUrl
    }
    url.hostname = url.hostname.replace(/\.corksy\.io$/i, greenHostMarker)
    return url.toString().replace(/\/$/, '')
  } catch (e) {
    return baseUrl
  }
}
    var blueBase = "https://mf-reservation.corksy.io"
    var buildVersion = "v2.501-01c6ebd-26-11-05-091518"
    var entry = '/corksy-reservations-v2.js?v=' + buildVersion
    var scope = 'corksyReservationsV2'
    
    function toRemote(container) {
      return {
        get: function (request) {
          return container.get(request)
        },
        init: function (shareScope) {
          if (!shareScope) {
            return Promise.resolve()
          }
          return Promise.resolve(container.init(shareScope)).catch(function (e) {
            if (
              e &&
              typeof e.message === 'string' &&
              e.message.indexOf('already been initialized') !== -1
            ) {
              return
            }
            console.error('[mf] remote container init failed', e)
            throw e
          })
        },
      }
    }

    function removeScript(script) {
      if (script && script.parentNode) {
        script.parentNode.removeChild(script)
      }
    }

    function tryLoad(host, done) {
      var script = document.createElement('script')
      script.src = host + entry
      script.onload = function () {
        var container = window[scope]
        if (!container || typeof container.get !== 'function') {
          removeScript(script)
          done(null)
          return
        }
        done(toRemote(container))
      }
      script.onerror = function () {
        removeScript(script)
        done(null)
      }
      document.head.appendChild(script)
    }

    var preferredHost = resolveHost(blueBase, window.location.hostname)

    tryLoad(preferredHost, function (remote) {
      if (remote) {
        resolve(remote)
        return
      }
      if (preferredHost === blueBase) {
        reject(new Error('Failed to load ' + scope))
        return
      }
      tryLoad(blueBase, function (fallbackRemote) {
        if (fallbackRemote) {
          resolve(fallbackRemote)
          return
        }
        reject(new Error('Failed to load ' + scope))
      })
    })
  });